import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { ToastifyContainer } from '../../components/Toastify/Toastify';

const Layout = (props) => {
  const { children } = props;

  return (
    <div className="layout">
      <Header />
      <ToastifyContainer />
      <main className="page">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
